import React from 'react';
import { DeleteButton, SaveButton, TopToolbar, useRedirect } from 'react-admin';
import { clsx } from 'clsx';
import { Button, Popconfirm } from 'antd';
import { SaveFilled } from '@ant-design/icons';
import { Dealer } from '@types';
import { MergeForm } from '@pages/dealer/MergeDealersForm';
import cls from './DealerForm.module.css';

interface ActionsProps {
  resource: string;
  record: Dealer | any;
  canEdit?: boolean;
  editPage?: boolean;
  onSalesforceSync?: () => void;
  onDeleteAccount?: () => void;
}

export const Actions = ({
  resource, record, canEdit, editPage, onSalesforceSync, onDeleteAccount,
}: ActionsProps) => {
  const redirect = useRedirect();

  const showDeleteAction = editPage && canEdit;
  const showMergeAction = editPage && canEdit;
  const showSFAction = editPage && canEdit;
  const showSaveAction = !editPage || canEdit;
  const showDeleteAccountAction = editPage && canEdit && !!record?.manager && onDeleteAccount;

  return (
    <TopToolbar className={cls.actions}>
      {showDeleteAction && (
        <DeleteButton
          className={clsx(cls.action, cls.actionDelete)}
        />
      )}

      {showDeleteAccountAction && (
        <Popconfirm title="Delete Account?" onConfirm={onDeleteAccount}>
          <Button className={clsx(cls.action, cls.actionDeleteAccount)}>
            Delete Account
          </Button>
        </Popconfirm>
      )}

      {showMergeAction && (
        <MergeForm
          dealer={record as Dealer}
          isBig
          btnClass={clsx(cls.action, cls.actionMerge)}
        />
      )}

      {showSFAction && (
        <Button
          className={clsx(cls.action, cls.actionSF)}
          onClick={onSalesforceSync}
        >
          Salesforce Sync
        </Button>
      )}

      {showSaveAction && (
        <SaveButton
          icon={<SaveFilled className={cls.actionIcon} />}
          label="Save"
          type="button"
          className={clsx(cls.action, cls.actionSave)}
          variant="outlined"
          alwaysEnable
          mutationOptions={{
            onSuccess: (record) => {
              redirect(`/${resource}/${record.id}`);
            },
          }}
        />
      )}
    </TopToolbar>
  );
};
